import { useEffect, useState } from 'react';

import './gram-selector.scss';

const PRESETS = [50, 100, 150, 200];

export const GramSelector = ({ grams, onChange, compact = false }) => {
  const [inp, setInp] = useState(String(grams));

  useEffect(() => setInp(String(grams)), [grams]);

  const commit = (raw) => {
    const n = parseInt(raw, 10);
    const v = isNaN(n) ? 100 : Math.min(500, Math.max(10, n));
    setInp(String(v));
    onChange(v);
  };

  const pct = Math.round(((grams - 10) / 490) * 100);

  if (compact) {
    return (
      <div className="gram-selector gram-selector--compact">
        <div className="gram-selector__compact-value">
          <span>Portion size</span>
          <span className="gram-selector__val">
            {grams}
            <small>g</small>
          </span>
        </div>
        <div className="gram-selector__presets">
          {PRESETS.map((p) => (
            <button
              key={p}
              type="button"
              className={`gram-selector__preset${grams === p ? ' active' : ''}`}
              onClick={() => onChange(p)}
            >
              {p}g
            </button>
          ))}
        </div>
        <div className="gram-selector__compact-slider">
          <input
            type="range"
            className="gram-selector__range"
            min="10"
            max="500"
            step="5"
            value={grams}
            onChange={(e) => onChange(+e.target.value)}
            style={{
              background: `linear-gradient(to right, var(--accent-primary) ${pct}%, var(--background-variant) ${pct}%)`
            }}
          />
          <span>10–500 g</span>
        </div>
        <div className="gram-selector__row gram-selector__compact-stepper">
          <button
            type="button"
            className="gram-selector__adj"
            onClick={() => onChange(Math.max(10, grams - 10))}
          >
            −
          </button>
          <input
            type="number"
            className="gram-selector__inp"
            value={inp}
            min="10"
            max="500"
            onChange={(e) => {
              setInp(e.target.value);
              const n = parseInt(e.target.value, 10);
              if (!isNaN(n) && n >= 10 && n <= 500) onChange(n);
            }}
            onBlur={(e) => commit(e.target.value)}
          />
          <button
            type="button"
            className="gram-selector__adj"
            onClick={() => onChange(Math.min(500, grams + 10))}
          >
            +
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="gram-selector">
      <div className="gram-selector__head">
        <span>Portion size</span>
        <span className="gram-selector__val">
          {grams}
          <small>g</small>
        </span>
      </div>
      <div className="gram-selector__presets">
        {PRESETS.map((p) => (
          <button
            key={p}
            type="button"
            className={`gram-selector__preset${grams === p ? ' active' : ''}`}
            onClick={() => onChange(p)}
          >
            {p}g
          </button>
        ))}
      </div>
      <div className="gram-selector__row">
        <button
          type="button"
          className="gram-selector__adj"
          onClick={() => onChange(Math.max(10, grams - 10))}
        >
          −
        </button>
        <input
          type="number"
          className="gram-selector__inp"
          value={inp}
          min="10"
          max="500"
          onChange={(e) => {
            setInp(e.target.value);
            const n = parseInt(e.target.value, 10);
            if (!isNaN(n) && n >= 10 && n <= 500) onChange(n);
          }}
          onBlur={(e) => commit(e.target.value)}
        />
        <button
          type="button"
          className="gram-selector__adj"
          onClick={() => onChange(Math.min(500, grams + 10))}
        >
          +
        </button>
      </div>
      <input
        type="range"
        className="gram-selector__range"
        min="10"
        max="500"
        step="5"
        value={grams}
        onChange={(e) => onChange(+e.target.value)}
        style={{
          background: `linear-gradient(to right, var(--accent-primary) ${pct}%, var(--background-secondary) ${pct}%)`
        }}
      />
    </div>
  );
};
